$(document).ready(function(){
  // $('html,body').animate({ scrollTop: 0 }, '1');
  var windowHeight = $(window).height();
  var titleHeight = $('.title').height();
  var windowWidth = $(window).width();
  var titleWidth = $('.title').width();
  var titlePosX = $('.title').offset().left;
  var titlePosY = $('.title').offset().top;
  $('.title').css('transform','translate('+(((windowWidth-titleWidth)/2-titlePosX))+'px,'+(((windowHeight-titleHeight)/2-titlePosY))+'px)');
  $('.title').addClass('active');
  setTimeout(function(){
    $('.title').css('transition','600ms');
    $('.title').addClass('active2');
    $('.overlay_white').fadeOut(1000);
  },1600);
  setTimeout(function(){
    $('.title').css('z-index','3');
  },2200);
});



$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }else{
          This.removeClass('active');
        }
    });
  });

  $('.header_menu_btn').click(function(){
    $('.header_wrapper').addClass('open');
    $('.menu_open_overlay').show();
  });
  $('.header_close_btn').click(function(){
    $('.header_wrapper').removeClass('open');
    $('.menu_open_overlay').hide();
  });
  $('.header_menu ul li a').click(function(){
    $('.header_wrapper').removeClass('open');
    $('.menu_open_overlay').hide();
  });
  $('.menu_open_overlay').click(function(){
    $('.header_wrapper').removeClass('open');
    $('.menu_open_overlay').hide();
  });

});
